<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage starfieldview"
  >
    <header-area />

    <div class="worksView" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              Don't get lost online or offline.<br />Smart experience to meet on mobile
            </div>
            <div class="workSlogan mobile">
              Don't get lost<br />online or offline.<br />Smart experience to<br />meet on mobile
            </div>
            <div class="workTopDay">
              <p>스타필드 모바일 웹 &amp; 앱 리뉴얼</p>
              <ul>
                <li>Mobile web &amp; app</li>
                <li>2020.03.12</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://m.starfield.co.kr/" target="_blank" class="siteAddr"
                >https://m.starfield.co.kr/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/starfield"
                    title="모바일로 만나는 스마트한 경험"
                    hashtags="플립커뮤니케이션즈,스타필드"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/starfield"
                    title="모바일로 만나는 스마트한 경험"
                    hashtags="플립커뮤니케이션즈,스타필드 "
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="15"
              >&nbsp;Smart experience to meet on mobile</marquee-text
            ></span
          >
          <img src="@/assets/images/works_view/starfield/starfield_visual.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          전 세대가 다 함께 즐길 수 있는 대한민국 대표 복합 문화공간 스타필드. 스타필드를 찾는
          고객들은 오프라인뿐만 아니라, 모바일 채널로도 많은 혜택과 정보를 얻길 원합니다. 이에
          스타필드는 모바일 서비스에 대한 변화가 필요하다는 점을 인식하고 플립커뮤니케이션즈와 함께
          모바일 개편 작업을 진행했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <!-- Concept -->
        <div class="starfieldConcept">
          <div class="worksView">
            <div
              class="contsBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="starfieldNum">Mission</div>
              <div class="starfield_text">
                이번 프로젝트는 무엇보다 고객들이 모바일 채널에서 느끼는 어려움을 개선하는 데 중점을
                두었습니다. 가장 먼저 고객센터와 마케팅팀이 보유한 이용 고객의 불편사항을 수집하고,
                오픈 데이터를 활용해 스타필드 방문객의 다양한 니즈를 파악했습니다.
              </div>
            </div>
          </div>
        </div>
        <!-- //Concept -->
        <!-- section_1 : Focus1 -->
        <div class="starfieldSection1">
          <div class="grayBgInner">
            <div class="worksView">
              <div class="contsBox">
                <div
                  class="starfieldReview"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <div class="review1">
                    <strong class="rvTitle">스타필드 방문객의 리뷰</strong>
                    <ul>
                      <li class="grada1">
                        <div class="rvText">
                          아기데리고 가기좋은 쇼핑몰입니다. 수유실,유모차대...
                        </div>
                        <div class="rvMark">
                          <span class="rvName">이정훈</span>
                          <span class="rvStar">★★★★★</span>
                        </div>
                      </li>
                      <li class="grada2">
                        <div class="rvText">
                          다양한 제품 쇼핑 및 방문은 물론이고, 서점, 영화관...
                        </div>
                        <div class="rvMark">
                          <span class="rvName">정규목</span>
                          <span class="rvStar">★★★★★</span>
                        </div>
                      </li>
                      <li class="grada3">
                        <div class="rvText">
                          다양한 놀거리와 먹거리가 있는곳. 아이들을 동반하...
                        </div>
                        <div class="rvMark">
                          <span class="rvName">이재섭</span>
                          <span class="rvStar">★★★★★</span>
                        </div>
                      </li>
                      <li class="grada4">
                        <div class="rvText">
                          쾌적하고 여유로운 쇼핑몰, 물건 구성도 다양하고 극장...
                        </div>
                        <div class="rvMark">
                          <span class="rvName">문준영</span>
                          <span class="rvStar">★★★★★</span>
                        </div>
                      </li>
                      <li class="grada5">
                        <div class="rvText">
                          다양한 레스토랑과 먹을거리도 맛보고, 쇼핑도 하고...
                        </div>
                        <div class="rvMark">
                          <span class="rvName">박용수</span>
                          <span class="rvStar">★★★★★</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="review2">
                    <strong class="rvTitle">스타필드 웹사이트 불편사항</strong>
                    <ul>
                      <li class="grada1">
                        1. 한번에 정보를 찾기 어렵고, 매장 이벤트를 찾기 어렵습니다.
                      </li>
                      <li class="grada2">
                        2. 내가 원하는 매장만 찾고 싶고, 할인정보도 알고 싶습니다.
                      </li>
                      <li class="grada3">
                        3. 지금가면 주차가 가능 할까여? 어느 주차공간으로 진입해야하나여?
                      </li>
                      <li class="grada4">
                        4. 아쿠아필드는 찜질방이에여? 유모차, 토이 카트 예약이 가능 할까요?
                      </li>
                      <li class="grada5">
                        5. 음식점 이름과 메뉴는 어디서 보나요? 검색 기능이 불편합니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="worksView">
            <div class="contsBox">
              <div class="starfield_text">
                오프라인 방문 고객의 긍정적인 인식과는 달리, 온라인 방문 고객들은 큰 용량, 낮은
                가독성, 최신 이슈,혜택 관련 정보 탐색의 어려움 등 불편사항을 호소했습니다.<br />우리는
                이러한 문제를 해결하고, 오프라인 방문 고객의 긍정적 인식을 온라인 채널을 통해 더욱더
                극대화하기 위해 스타필드와의 컨설팅을 진행했습니다. 그리고 ‘모바일 사용자에게
                최적화된 UX/UI 구현’이라는 목표와 ‘사용성 증진’, ‘고객 관점의 콘텐츠 제공’,
                ‘스타필드 리브랜딩’ 이라는 세 가지 전략을 설정해 이번 모바일 개편 프로젝트를
                추진했습니다.
              </div>
              <div class="pGoalCyArea">
                <ul v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
                  <li class="pGoalCy1">
                    <div>
                      <p><strong>가장 가볍고</strong></p>
                    </div>
                    <p>꼭 필요로 하는 정보만 담은<br />가장 가벼운 가이드</p>
                  </li>
                  <li class="pGoalCy2">
                    <div>
                      <p><strong>스마트하고</strong></p>
                    </div>
                    <p>고객의 상황에 맞는 정보를<br />제공하는 스마트한 큐레이션</p>
                  </li>
                  <li class="pGoalCy3">
                    <div>
                      <p><strong>스타필드 다운</strong></p>
                    </div>
                    <p>온라인에서 즐기는<br />특별한 스타필드</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- //section_1 : Focus1 -->
        <!-- section_2 : Focus2 -->
        <div class="starfieldSection2">
          <div class="starfieldConcept">
            <div class="worksView">
              <div
                class="contsBox"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="starfieldTitle">
                  <div class="starfieldNum">Execution</div>
                  <div class="starfield_text">Usability - 가장 가벼운 스타필드 모바일 가이드</div>
                  <div class="starfield_tit">모바일 속도 최적화</div>
                </div>
                <div class="starfield_text">
                  기존 모바일 채널의 큰 용량과 느린 속도는 빈번하게 제기되는 불편사항 중
                  하나였습니다. 해당 문제점을 개선하기 위해 가장 먼저 불필요한 요소를 정제하는
                  작업을 진행했습니다.<br />
                  특히 무거운 벡터 형식과 무용한 기능으로 용량의 대부분을 차지했던 지도 서비스는
                  층별 매장 안내, 확대 축소 등의 이용률이 높은 기능 위주로 가볍게 개편하고, 이미지로
                  노출되던 주요 정보를 텍스트 중심으로 구현함으로써 모바일 구성 용량을 28% 축소하고,
                  페이지 이동 속도를 25% 향상시켰습니다.
                </div>
                <div class="mguide">
                  <div>
                    <div class="txt">
                      <strong>사용속도</strong>메인화면 및 페이지 이동 로딩 속도
                    </div>
                    <div class="secAndMb">
                      <div
                        class="secAndMbInner inr1"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        <strong class="asIs">8sec</strong>
                        <span class="toBe">2sec</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="txt"><strong>용량</strong>모바일 앱 구성 용량</div>
                    <div class="secAndMb">
                      <div class="secAndMbInner inr2">
                        <strong class="asIs">42mb</strong>
                        <span class="toBe">32mb</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="starfieldTitle">
                  <div class="starfield_tit stsecond">
                    이용 고객들이 필요로 하는 정보에 집중한 UX &middot; UI
                  </div>
                </div>
                <div class="starfield_text">
                  오프라인 시설 정보 위주로 노출되던 기존 메인화면을 스타필드가 진행하는 이벤트,
                  제공하는 혜택과 최신 정보 중심으로 개편했습니다. 특히 메인 콘텐츠를 이미지, 동영상
                  등을 활용한 역동적이고 다양한 비주얼의 배너 형태로 노출해 각각의 콘텐츠에 대한
                  집중도를 높였습니다.<br />
                  또한 불필요한 페이지 이동을 야기했던 기존의 메뉴 구조를 과감하게 해체하고 매장
                  안내, 개인 정보, 포인트, 쿠폰 등 고객이 자주 찾는 10개의 핵심적인 메뉴로 재구성해
                  이용에 편리함을 더했습니다.
                </div>
              </div>

              <div class="uxuiBox">
                <div class="uxui">
                  <ul v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
                    <li>
                      <img src="@/assets/images/works_view/starfield/exc_img1.png" alt="" />
                    </li>
                    <li>
                      <img src="@/assets/images/works_view/starfield/exc_img2.png" alt="" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //section_2 : Focus2 -->
        <!-- section_3 : Focus3 -->
        <div class="starfieldSection3">
          <div class="starfieldConcept">
            <div class="grayBgInner">
              <div class="worksView">
                <div class="contsBox">
                  <div class="starfieldTitle">
                    <div class="starfield_text">
                      Contents -
                      <span class="tablet_block">방문 고객이 원하는 정보를 스마트하게</span>
                    </div>
                  </div>

                  <div class="contentsSub1">
                    <div class="sec3_sub1_1">
                      <div
                        class="starfield_tit_inSub"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        고객의 상황을 고려한 스마트한 검색 서비스
                      </div>
                      <div
                        class="starfield_text"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        통합 검색 페이지에는 신규 오픈 매장, 신세계 상품권 사용 가능 매장, 반려견과
                        함께 이용 가능한 장소 등 고객의 상황에 따라 검색어를 선택할 수 있는 추천
                        태그 서비스 외에도 인기 검색 브랜드, 최근 검색어 등의 콘텐츠를 함께 구성해
                        고객이 카테고리,혜택,방문 형태별로 원하는 정보에 보다 쉽게 접근할 수 있도록
                        배려했습니다.
                      </div>
                    </div>
                    <div
                      class="sec3_sub1_2"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <img src="@/assets/images/works_view/starfield/find_img.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="contentsSub2">
                <div class="worksView">
                  <div class="contsBox">
                    <div class="sec3_sub2_1">
                      <div
                        class="starfield_tit_inSub"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        페이지 이동 없이 한눈에 보는 매장정보
                      </div>
                      <div
                        class="starfield_text"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        고객이 가장 즐겨 찾고 오래 머무는 페이지는 매장 안내 페이지임에도 기존
                        채널은 입점 브랜드 관련 최소한의 콘텐츠만을 제공했기 때문에 고객이 산재된
                        연계 서비스를 직접 찾아야 하는 불편함이 있었습니다. 개선된 모바일 채널에서는
                        페이지 이동 없이 매장별 이벤트, 할인 정보, 핫플레이스 등 브랜드 관련된
                        정보를 한눈에 확인할 수 있도록 통합된 페이지를 구성했습니다.
                      </div>
                    </div>
                    <div
                      class="sec3_sub2_2"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <img src="@/assets/images/works_view/starfield/store_position.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="contentsSub3">
                <div class="worksView">
                  <div class="contsBox">
                    <div class="sec3_sub3_1">
                      <div
                        class="starfield_tit_inSub"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        시점별 정보 제공으로 더욱 편리해진 차량관련 시스템
                      </div>
                      <div
                        class="starfield_text"
                        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                      >
                        고객의 방문 시점에 따라 방문하기 전에는 층별 주차 혼잡도와 실제 주차현황
                        정보를 미리 확인할 수 있도록 UI를 개선했습니다. 방문 시에는 ‘내차찾기’
                        페이지에서 차량 위치를 확인할 수 있도록 하고, ‘내차등록’ 서비스를 활용해
                        초기에 차량 번호를 입력한 이후에는 차량 번호 선택만으로 위치 조회가
                        가능하도록 구현했습니다.
                      </div>
                    </div>
                    <div
                      class="sec3_sub3_2"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <img src="@/assets/images/works_view/starfield/motor_positon.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- section_3 : Focus3 -->
        <!-- section_4 : Focus4 -->
        <div class="starfieldSection4">
          <div class="worksView">
            <div class="contsBox">
              <div class="starfieldTitle">
                <div class="starfield_text">
                  Branding -
                  <span class="tablet_block">스타필드다운, 스타필드만의 차별화 콘텐츠</span>
                </div>
              </div>
            </div>
          </div>

          <div class="brandingSub1">
            <div class="worksView">
              <div class="contsBox">
                <div class="sec4_sub1_1">
                  <div class="starfield_tit_inSub">
                    콘텐츠 접근성과 편의성을 높인 별마당 도서관 페이지
                  </div>
                  <div class="starfield_text">
                    스타필드 코엑스의 랜드마크이자 세계인이 찾아오는 별마당 도서관은 양질의
                    공연/강연 콘텐츠를 보유하고 있음에도 기존 디지털 채널의 한계로 인해 관련
                    정보들이 효과적으로 노출되지 못하고 있었습니다. 먼저 혼재된 정보를 재구성하고,
                    공연 정보들을 데이터베이스화해 검색이 가능하도록 구현했습니다. 또한 외부 채널로
                    이동해야만 했던 공연 신청 기능을 내재화하고 신청 정보 관리까지 가능하도록
                    했습니다.
                  </div>
                </div>
              </div>
            </div>
            <div class="sec4_sub1_2">
              <div class="brand_system">
                <div class="b_system_Box">
                  <ul>
                    <li
                      class="b_system_Li1"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <div>
                        <img
                          src="@/assets/images/works_view/starfield/branding_contents1.png"
                          alt=""
                        />
                      </div>
                      <p>
                        별마당소개 부터 별마당 굿즈까지<br />
                        <strong>
                          한눈에 보고, 원하는 메뉴로<br />
                          바로 찾아가는 구조로 변경
                        </strong>
                      </p>
                    </li>
                    <li
                      class="b_system_Li2"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <div>
                        <img
                          src="@/assets/images/works_view/starfield/branding_contents2.png"
                          alt=""
                        />
                      </div>
                      <p>
                        지난강연&#47;공연 , 이달의 강연&#47;공연 &#47; 후기영상<br />
                        <strong>
                          모든 공연을 확인할 수 있도록<br />
                          시점별 공연 정보 제공
                        </strong>
                      </p>
                    </li>
                    <li
                      class="b_system_Li3"
                      v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                    >
                      <div>
                        <img
                          src="@/assets/images/works_view/starfield/branding_contents3.png"
                          alt=""
                        />
                      </div>
                      <p>
                        기존 외부 서비스를 통해서만 가능했던 관람<br />신청을
                        <strong>
                          홈페이지에서 가능하도록 내재화하고<br />
                          신청 내역을 관리할 수 있도록 개선
                        </strong>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="brandingSub2">
            <div class="worksView">
              <div class="brandingBox">
                <div class="sec4_sub2_1">
                  <div class="text_area">
                    <div class="starfield_tit_inSub">스타필드를 Fun하게 소개하는 SPECIAL MAP</div>
                    <div class="starfield_text">
                      일러스트와 인터랙션을 활용해 지점별 랜드마크와 핫플레이스, 이벤트, 공연 관련
                      정보들을 하나의 MAP에 생동감 있게 구성했습니다.<br />이를 통해 각 지점의 특색
                      있는 서비스와 정보를 흥미롭게 제공함과 동시에 ‘쇼핑 테마파크’라는 스타필드의
                      브랜드 아이덴티티를 극대화하고자 했습니다.
                    </div>
                  </div>

                  <div class="img_area">
                    <ul>
                      <li>
                        <img src="@/assets/images/works_view/starfield/small_map1.png" alt="" />
                      </li>
                      <li>
                        <img src="@/assets/images/works_view/starfield/small_map2.png" alt="" />
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="sec4_sub2_2"
                  v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
                >
                  <img src="@/assets/images/works_view/starfield/map_img.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //section_4 : Focus4 -->
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-tigerE' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">미래에셋 TIGER ETF</strong>
          <strong class="mobile">미래에셋<br />TIGER ETF</strong>
        </div>

        <div class="engBg starfieldEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '스타필드'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "스타필드 모바일 웹&앱 | 플립커뮤니케이션즈",
        title: "스타필드 모바일 웹&앱",
        desc:
          "스타필드 모바일 웹/앱은 고객의 상황과 니즈에 맞춰 제공하는 스마트한 서비스, 가벼운 UX/UI로 모바일 사용성 향상을 위해 리뉴얼했습니다. 통합 검색, 매장정보 제공, 차량위치 확인 등의 서비스와 별마당 도서관, 스페셜 맵 등 차별화 콘텐츠로 스타필드만의 가치를 전달합니다.",
        keywords:
          "스타필드, 모바일 웹, 앱, 리뉴얼, 스마트 경험, 대한민국 대표 복합 문화공간, 온라인 서비스, 변화, 플립커뮤니케이션즈, 모바일 개편, 고객 만족도, 플립커뮤니케이션즈 컨설팅, UX/UI 개선, 사용성 증진, 온라인 채널",
        url: "https://www.pulip.com/works/starfield",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/starfield").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {}
};
</script>
